import React from "react";

interface TotalSmallBadgeProps {
    label?: string;
}

const TotalSmallBadge: React.FC<TotalSmallBadgeProps> = ({ label }) => {
    return (
        <span
            className="ml-1 px-1 py-0.5 rounded bg-gray-200 text-gray-800 font-semibold text-sm relative"
            style={{ top: '-5px', fontSize: '0.7rem' }}
        >
            {label}
        </span>
    );
};

export default TotalSmallBadge;
